module.exports = __webpack_public_path__ + "static/img/2025年历-12.8d8d86f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-12.png
// module id = L88e
// module chunks = 3